import { newClient } from '../axios-client-factory'
import { fileClient } from '../axios-client-file'


export const mobeilLogin = function(json) {
  return newClient().post('/guild/guilder/login', json)
}
export const changeMobile = function(json) {
  return newClient().post('/guild/guilder/updateMobile', json)
}

/**
 * 手机、密码登录
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const mobilePwdLogin = function(data) {
  return newClient().post('/guild/guilder/pwdLogin', data)
}


/**
 * 获取图片验证码
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const picCaptcha = function(t) {
  return fileClient().get('/guild/guilder/captcha/'+ t);
}

/**
 * 注册
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const mobilePwdRegister = function(data) {
  return newClient().post('/guild/guilder/pwdRegister', data)
}


/**
 * 绑定手机号(注册或者绑定)
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const mobilePwdBind = function(data) {
  return newClient().post('/guild/guilder/phoneBind', data)
}
/**
 * 注册
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const forgetPwd = function(data) {
  return newClient().post('/guild/guilder/forgetPwd', data)
}

/**
 * 二维码登录绑定手机、密码
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const bindPhonePwd = function(data) {
  return newClient().post('/guild/guilder/bindInfo', data)
}

/**
 * 二维码登录绑定手机、密码
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const tokenLoginAjax = function(data) {
  return newClient().post('/guild/guilder/tokenLogin', data)
}




// WEBPACK FOOTER //
// ./src/api/login/login.js